import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createBuyerSellerDumpReportApi } from "./api";
import { BuyerSellerDumpReportReduxTypes } from "./types";

function* createBuyerSellerDumpReportSaga(action:any):Generator {
    try {
        const response: any = yield call(createBuyerSellerDumpReportApi, action.payload);
        yield put({
            type: BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateBuyerSellerDumpReport(): SagaIterator {
    yield takeEvery(BuyerSellerDumpReportReduxTypes.BUYER_SELLER_DUMP_REPORT, createBuyerSellerDumpReportSaga);
}

function* BuyerSellerDumpReportSaga(): SagaIterator {
    yield all([fork(watchCreateBuyerSellerDumpReport)]);
}

export default BuyerSellerDumpReportSaga;  